import styled from 'styled-components';

/*
 * RES-1367: no margins of its own any more.
 *
 * This used to carry `margin-top: -18px` plus a trailing `margin-bottom`, tuned to cancel out the
 * 28px lead-in of the ONE block it was ever rendered inside. The moment that block was asked for
 * its `section` variant -- a 16px lead-in -- the -18px overshot it, and the first question climbed
 * on top of the "Additional information" heading above it, with 24px of dead space left under the
 * last answer for good measure.
 *
 * A child that negates its parent's spacing is a child that can only live under one parent. The
 * spacing between responses belongs to the stack that holds them (CollapsableBlock's `Content` is
 * a flex column with its own gap), so it is left there.
 */
export const Container = styled.div``;

export const Question = styled.div`
  font: 500 14px/16px ${({ theme }) => theme.fonts.join()};
`;

export const Answer = styled.div`
  font: 400 14px/16px ${({ theme }) => theme.fonts.join()};
  margin-top: 4px;
`;
